module.exports = __webpack_public_path__ + "media/img/sda/cardiff-student-banner-5b644612cdaa11d1964a57babfd9cae3.png";